import React, { FunctionComponent } from 'react';
import { useParams } from 'react-router-dom';
import { Card, Grid, Stack } from '@mui/material';
import { LectionImageDto } from '../../dto/LectionImageDto';
import { RESOURCE_URL } from '../../setting/AppSettings';
import {
  getImageVideoSize,
  getPageNumId,
  secureContent,
} from '../../utils/utils';

interface Props {
  idPage: string;
  dto?: LectionImageDto;
}

export const WorksapceSlideImageItemDiv: FunctionComponent<Props> = ({
  idPage,
  dto,
}) => {
  const { section, route } = useParams();
  const page = getPageNumId(idPage);
  return (
    <Grid container spacing={1}>
      {dto?.images.map((item) => (
        <Grid item xs={4}>
          <Card style={{ width: '100%' }}>
            <Stack height={500} alignItems="center" justifyContent="center">
              {item.name.includes('.png') && (
                <img
                  width={getImageVideoSize(item, 330, 375)[0]}
                  height={getImageVideoSize(item, 330, 375)[1]}
                  alt="not found"
                  src={`https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${route}&page=page_${page}&name=${
                    item.name
                  }&${secureContent()}`}
                />
              )}
              {item.name.includes('.mp4') && (
                <video width="100%" playsInline autoPlay muted loop>
                  <source
                    src={`https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${route}&page=page_${page}&name=${
                      item.name
                    }&${secureContent()}`}
                    type="video/mp4"
                  />
                </video>
              )}
            </Stack>
          </Card>
        </Grid>
      ))}
      {dto?.zoomImage && dto?.zoomImage.name !== '' && (
        <Grid item xs={4}>
          <Card>
            <Stack height={500} alignItems="center" justifyContent="center">
              <img
                style={{
                  transform: `scale(${dto.zoomImage.zoom})`,
                }}
                width={getImageVideoSize(dto.zoomImage, 330, 375)[0]}
                height={getImageVideoSize(dto.zoomImage, 330, 375)[1]}
                alt="not found"
                src={`https://uchianat.ru/api/contentUrl.php?section=${section}&lectionId=${route}&page=page_${page}&name=${
                  dto.zoomImage.name
                }&${secureContent()}`}
              />
            </Stack>
          </Card>
        </Grid>
      )}
    </Grid>
  );
};

WorksapceSlideImageItemDiv.defaultProps = {
  dto: undefined,
};
